import { ProtoBaseModel, attr, repeated } from '@square/dashboard-data/utils/ember-model-stubs';
import { KDSFetchSettings } from '@square/dashboard-protos/models/squareup/devicesettings/profiles/v2/model/settings/kds/kds_fetch_settings';
import { ApplicationType } from '@square/dashboard-protos/models/squareup/devices/external/application_type';
export const DiningOptionConfiguration = ProtoBaseModel.extend({
  catalogObjectId: attr(String),
  selected: attr(Boolean),
  displayName: attr(String)
});
export const CategoryConfiguration = ProtoBaseModel.extend({
  catalogObjectId: attr(String),
  enabled: attr(Boolean),
  isKitchen: attr(Boolean),
  displayName: attr(String)
});
export const POSDeviceConfiguration = ProtoBaseModel.extend({
  deviceCredentialId: attr(String),
  displayName: attr(String),
  enabled: attr(Boolean),
  productType: attr(String)
});
export const POSDeviceRoutingConfiguration = ProtoBaseModel.extend({
  deviceId: attr(String),
  deviceCredentialToken: attr(String),
  displayName: attr(String),
  enabled: attr(Boolean),
  posApplicationType: attr(ApplicationType)
});
export const DeviceIdRoutingConfiguration = ProtoBaseModel.extend({
  includeFuturePosDeviceEnabled: attr(Boolean),
  posRoutingConfigurations: repeated(POSDeviceRoutingConfiguration)
});
export default ProtoBaseModel.extend({
  categories: repeated(CategoryConfiguration),
  uncategorizedEnabled: attr(Boolean),
  includeFutureCategoriesEnabled: attr(Boolean),
  ordersEnabled: attr(Boolean),
  displayOrderOnState: attr(KDSFetchSettings.DisplayOrderConfigurationState),
  stationOnPickupBufferSeconds: attr(Number),
  posEnabled: attr(Boolean),
  posDeviceConfigurations: repeated(POSDeviceConfiguration),
  includeFutureNamedPosEnabled: attr(Boolean),
  includeUnnamedPosEnabled: attr(Boolean),
  coursingDisplayType: attr(KDSFetchSettings.CoursingDisplayType),
  includeFutureDiningOptionsEnabled: attr(Boolean),
  diningOptionConfigurations: repeated(DiningOptionConfiguration),
  useSingleStationCompletion: attr(Boolean),
  deviceIdRoutingConfiguration: attr(DeviceIdRoutingConfiguration),
  stationType: attr(String)
});